<div class="flex flex-col w-full justify-center items-center pt-[20vh] gap-4">
  <div class="text-6xl font-bold">404</div>
  <h1>{{ 'LAYOUT.PAGE_NOT_FOUND' | translate }}</h1>

  <pm-button
    variant="primary"
    (handleClick)="goBack()"
    text="LAYOUT.PAGE_NOT_FOUND_BACK_HINT"
    class="mt-4"
  />
</div>
